module.exports = __webpack_public_path__ + "img/tuskegee.dee363b1.jpg";